import React from 'react';
import { Container } from 'reactstrap';

import { useSelector } from 'react-redux';
import {
  isAdmin as isAdminSelector,
  isSubscriber as isSubscriberSelector,
  isAffiliate as isAffiliateSelector,
} from '../../selectors/auth';

import AdminDashboard from './admin';
import SubscriberDashboard from './subscriber';
import AffiliateDashboard from './affiliate';

const Dashboard = () => {
  const isAdmin = useSelector(isAdminSelector);
  const isSubscriber = useSelector(isSubscriberSelector);
  const isAffiliate = useSelector(isAffiliateSelector);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {isAdmin && <AdminDashboard />}
          {isSubscriber && <SubscriberDashboard />}
          {isAffiliate && <AffiliateDashboard />}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
